document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');
    setupRutBlurListener();
    setupCalendar();
    initializeClinics();

    const debugStep = 1; // Cambia este valor para definir el paso inicial (1, 2 o 3). Elimina o comenta esta línea en producción.
    console.log(`Initial step set to: ${debugStep}`);
    setInitialStep(debugStep);

    const continueButton = document.getElementById('continueButton');
    continueButton.addEventListener('click', handleNextStep);

});

document.addEventListener('DOMContentLoaded', function() {
    const fixedBtnContainers = document.querySelectorAll('.fixed-btn-container'); // Selecciona todos los contenedores
    const footer = document.querySelector('.footer'); // Asegúrate de que este selector coincida con tu pie de página

    // Configuración del observador de intersección
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            // Aplica el comportamiento a todos los elementos con la clase `.fixed-btn-container`
            fixedBtnContainers.forEach(fixedBtnContainer => {
                if (entry.isIntersecting) {
                    // Si el footer es visible, oculta el botón (slide-up)
                    fixedBtnContainer.classList.remove('slide-down');
                    fixedBtnContainer.classList.add('slide-up');
                } else {
                    // Si el footer no es visible, muestra el botón (slide-down)
                    fixedBtnContainer.classList.remove('slide-up');
                    fixedBtnContainer.classList.add('slide-down');
                }
            });
        });
    });

    // Observa el footer
    observer.observe(footer);
});
